module.exports = __webpack_public_path__ + "static/media/splashDarkResBg.410fa19c.svg";